import { render, staticRenderFns } from "./ShowAll.vue?vue&type=template&id=63b5a1ce&scoped=true"
import script from "./ShowAll.vue?vue&type=script&lang=js"
export * from "./ShowAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b5a1ce",
  null
  
)

export default component.exports